export default "__VITE_ASSET__BBERMNMt__"